import React from 'react'
import Heading from '../../components/Heading'
import IconButton from '../../components/IconButton'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import ButtonSettingsForm from '../../compositions/Settings/ButtonSettings/ButtonSettingsForm/ButtonSettingsForm'
import { useNavigate } from 'react-router-dom'

const ButtonSettings: React.FC = () => {
    const { t } = useTranslation(['settings'])
    const navigate = useNavigate()

    return (
        <>
            <Heading level={3} classes={'zr-my-4'}>
                {t('button.heading')}
            </Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => navigate('/settings')}
            >
                {t('common.backToOverview')}
            </IconButton>
            <ButtonSettingsForm />
        </>
    )
}

export default ButtonSettings
